<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .add-email {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: utils.in_rem(12px);
  }
</style>

<script>
  // Components
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";

  export let onclick = () => {};
</script>

<div class="add-email">
  <ButtonWithTooltip
    kind="primary"
    size="small"
    leadingIcon="fa-regular fa-plus"
    {onclick}
    placement="top"
  >
    <span slot="tooltip"> Copy </span>
  </ButtonWithTooltip>
  <slot />
</div>
